var _mask, _path, _g, _path2, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 128,
    viewBox: "0 0 128 128",
    width: 128,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 124,
    maskUnits: "userSpaceOnUse",
    width: 124,
    x: 2,
    y: 2
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m64 126c34.2417 0 62-27.7583 62-62s-27.7583-62-62-62-62 27.7583-62 62 27.7583 62 62 62z",
    fill: "#b1ecff",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m64 126c34.2417 0 62-27.7583 62-62s-27.7583-62-62-62-62 27.7583-62 62 27.7583 62 62 62z",
    fill: "#b1ecff",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 92h122v39h-122z",
    fill: "#1253fc"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m62.6802 119v-4.68h-9.27v-3.75h7.92v-4.68h-7.92v-3.57h9.27v-4.68h-14.52v21.36z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m81.9221 112.22h-5.34c-.33 1.2-.99 2.28-2.73 2.28-.96 0-1.68-.39-2.07-.9-.48-.63-.81-1.38-.81-5.28s.33-4.65.81-5.28c.39-.51 1.11-.9 2.07-.9 1.74 0 2.4 1.08 2.73 2.28h5.34c-.78-4.71-4.05-6.96-8.1-6.96-2.49 0-4.38.84-5.94 2.4-2.25 2.25-2.16 5.25-2.16 8.46s-.09 6.21 2.16 8.46c1.56 1.56 3.45 2.4 5.94 2.4 4.05 0 7.32-2.25 8.1-6.96z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.5299 35.8592c0-9.7321-4.6591-18.1007-8.2039-20.8241-.0147-.0094-.2721-.1572-.2501.2338 0 .0037-.0036.0056-.0036.0112-.2942 18.7891-9.73 23.8806-14.9167 30.7415-11.9712 15.83-.8384 33.1863 10.4985 36.3942 6.3432 1.7938-1.4654-3.1761-2.4711-13.6752-1.2153-12.6894 15.3469-22.3767 15.3469-32.8814z",
    fill: "#1253fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.7488 42.2557c-.0772-.0505-.1876-.0841-.2629.0356-.2078 2.3662-2.7432 7.424-5.9553 12.0703-10.8974 15.757-4.6884 23.3549-1.1969 27.4345 2.028 2.368 0 0 5.0672-2.4204.399-.1908 9.888-5.2636 10.9158-16.8214.9947-11.193-6.0582-18.2485-8.5679-20.2986z",
    fill: "#00ace4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeco);
export default __webpack_public_path__ + "static/media/HECO.a968f63fc2100c289901bd78e212ac70.svg";
export { ForwardRef as ReactComponent };